// api
import api from 'apiSingleton';

// lodash
import { clamp } from 'lodash';

// notifications
import { addNotification } from './notifications';

// constants
import { SPECIFICATIONS_PAGE_STEPS as STEPS } from 'constants/specificationsPageSteps';
import {
  BEGIN_STEP,
  BEGIN_NEXT_STEP,
  BEGIN_PREVIOUS_STEP,
  SET_STEP_DATA,
  SET_PAGE_LOADING,
  //
  ADD_WORKING_AREA_SPECIFICATION,
  REMOVE_WORKING_AREA_SPECIFICATION,
  CLEAR_WORKING_AREA_SPECIFICATIONS,
} from '../constants/specifications';

export const beginStep = (step, data = {}) => ({
  type: BEGIN_STEP,
  payload: { step, data },
});

export const beginNextStep = (data = {}) => ({
  type: BEGIN_NEXT_STEP,
  payload: { step: 1, data },
});

export const beginPreviousStep = (data = {}) => ({
  type: BEGIN_PREVIOUS_STEP,
  payload: { step: -1, data },
});

/* export */ const setPageLoading = (isLoading) => ({
  type: SET_PAGE_LOADING,
  payload: isLoading,
});

/* export */ const setStepData = (data) => ({
  type: SET_STEP_DATA,
  payload: data,
});

/* Working Area actions */

/* export */ function addWorkingAreaSpecification(specification) {
  return {
    type: ADD_WORKING_AREA_SPECIFICATION,
    payload: specification,
  }
}

export function removeWorkingAreaSpecification(article) {
  return {
    type: REMOVE_WORKING_AREA_SPECIFICATION,
    payload: article,
  }
}

export function clearWorkingAreaSpecifications() {
  return { type: CLEAR_WORKING_AREA_SPECIFICATIONS }
}

/* End working area actions */

/* Steps actions */

// Step 1
export function selectRestaurant(restaurant) {
  return async (dispatch) => {
    dispatch(setPageLoading(true));

    const { data: categories } = await api.settings.getProductCategories({ restaurant, status: 1 });
    const beginStepAction = beginStep(STEPS.STEP_SELECT_PRODUCT_CATEGORY, {
      restaurant,
      categories,
    });

    dispatch(beginStepAction);
    dispatch(setPageLoading(false));
  }
}

// Step 2
export function selectProductCategory(syncId) {
  return async (dispatch) => {
    const beginStepAction = beginStep(STEPS.STEP_SELECT_PRODUCT, {
      category: syncId,
      // clean products state
      products: [],
      productsMeta: {},
    });

    dispatch(beginStepAction);
  }
}

// Step 3

export function fetchProducts(searchQuery) {
  return async (dispatch, state) => {
    const {
      specifications: {
        page: {
          step: {
            data: {
              restaurant,
              category,
              products,
              productsMeta: {
                search: lastSearch,
                current_page: currentPage = 0,
                last_page: lastPage = 1,
              } = {},
            }
          },
        }
      }
    } = state();

    const search = searchQuery || undefined;
    const searchUnchanged = lastSearch === search;

    if ((currentPage >= lastPage) && searchUnchanged) return;

    dispatch(setPageLoading(true));

    const response = await api.products.getList({
      search,
      category_sync_id: category,
      restaurant,
      page: searchUnchanged ? clamp(currentPage + 1, 1, lastPage) : 1,
      per_page: 20,
    });

    if (response.errors) {
      dispatch(addNotification(res.errors, 'error'));
    } else {
      dispatch(setStepData({
        products: searchUnchanged ? [...products, ...response.data] : response.data,
        productsMeta: { ...response.meta, search },
      }));
    }

    dispatch(setPageLoading(false));

  }
}

export function selectProduct({ article, restaurant }, parent) {
  return async (dispatch, state) => {

    dispatch(setPageLoading(true));
    const {
      specifications: {
        page: {
          workingArea: {
            specifications,
          }
        }
      }
    } = state();

    const index = specifications.findIndex(function (item) {
      return item.article === article;
    });

    if (index === -1) {
      const { success, data } = await api.products.getProductSpecification(article);
      if (success) {
        const [{ specific: specification }] = data;
        const { name, Items: items } = specification;
        dispatch(addWorkingAreaSpecification({
          article,
          restaurant,
          name,
          items,
          parent,
        }));
      }
    } else {
      dispatch(addNotification({ error: ['Тех. карту цього продукту вже додано'] }, 'error'));
    }

    dispatch(setPageLoading(false));
  }
}

/* End steps actions */
